import { BookOutlined } from '@ant-design/icons';
import { ModuleDefinition } from '../types';
import { createNavItem } from '@/utils/navigation';

// Module translations
import en from './locales/en.json';
import de from './locales/de.json';
import bg from './locales/bg.json';

/**
 * Knowledge Base Module
 *
 * Provides a knowledge base management interface.
 * Connects to an external Knowledge Base API with admin and read-only access tokens.
 */

// Module configuration constants
const MODULE_NAME = 'knowledgeBase';
const ROUTE_NAMESPACE = 'manage' as const;

/**
 * Base route path for this module
 * Use this constant throughout the module to avoid duplication
 */
export const MODULE_BASE_ROUTE = `/${ROUTE_NAMESPACE}/modules/${MODULE_NAME}`;

export const module: ModuleDefinition = {
  id: 'knowledge-base-module',
  name: 'Knowledge Base Module',
  version: '1.0.0',
  description: 'Manage knowledge base content and documents',
  author: 'System',
  category: 'content',

  // Route namespace - determines where module routes are mounted
  routeNamespace: ROUTE_NAMESPACE,

  // Global roles required
  requiredRoles: ['USER', 'ADMIN'],

  // Tenant roles required
  requiredTenantRoles: ['OWNER', 'EMPLOYEE'],
  useServerRelay: true,

  // Navigation items to add
  navigationItems: [createNavItem('ext-knowledge-base', <BookOutlined />, 'Knowledge Base Module', MODULE_BASE_ROUTE, false)],

  // Configuration schema
  configSchema: {
    type: 'object',
    properties: {
      apiBaseUrl: {
        type: 'string',
        description: 'The base URL for the Knowledge Base API',
        required: true,
        serverOnly: true,
      },
      adminToken: {
        type: 'string',
        description: 'Admin API token with full read/write access to the Knowledge Base API',
        required: true,
        serverOnly: true,
      },
      readToken: {
        type: 'string',
        description: 'Read-only API token for querying the Knowledge Base API',
        required: true,
        serverOnly: true,
      }
    }
  },

  // Module translations (registered as i18n namespace 'knowledge-base-module')
  translations: { en, de, bg },

  // Lifecycle hooks
  onLoad: async () => {
    console.log('Knowledge Base Module loaded');
  },
};

// Export as default
export default module;
